// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardListStyles } from "@bg/App/Components/SavedPayments/SavedPaymentsCard";
import { xScreen } from "@bg/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cardListStyles.actionsContainer = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            opacity: 1;
            position: static;
            margin: auto;
        }
        ${xScreen("lte", "md")} {
            flex-direction: row;
            opacity: 1;
            position: static;
        }

        height: 75px;
        background: ${getColor("common.white")};
        color: ${getColor("text.main")};
        padding: 10px 20px;
        left: 0;
        position: absolute;
        bottom: 0;
        width: 100%;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 2;
    `,
};
